module.exports = __webpack_public_path__ + "img/fancy@2x.0a2a11a.jpg";